/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.endProjectAction.REQUEST_ENDPROJECT:
      return {
        ...state
      };
    case actions.endProjectAction.ENDPROJECT_RECEIVED:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default reducer;
